import React, { useCallback, useMemo } from 'react';
import { TypedMemo } from '../../common/types';
import { useUser } from '../../users/hooks/useUser';
import { useWorkspaces } from '../../workspaces/useWorkspaces';
import { AccountSignInCard } from './account/AccountSignInCard';
import { AccountLanguageCard } from './account/AccountLanguageCard';
import { SignInMethodsCard } from './account/signInMethods/SignInMethodsCard';
import { AccountActionsCards } from './account/AccountActionsCards';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Settings tabs; each part uses its own slice of it */
import cards from './settingsCards.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** Settings → Account (design settings-redesign b1). */
const AccountTabComponent: React.FC = () => {
  const { data: user, refetch } = useUser();
  const { workspaces } = useWorkspaces();
  // Read the user again, so `user.music24Locale` in the cache is the saved language.
  const onLanguageSaved = useCallback(() => {
    refetch().catch(console.error);
  }, [refetch]);

  const email = user?.user.email ?? '';
  // The server names a workspace with no custom name and no artist after its owner's email.
  const homeWorkspaceName = useMemo(
    () => workspaces.find((workspace) => workspace.isHome)?.name ?? email,
    [email, workspaces]
  );

  return (
    <div className={cards.pane}>
      <AccountSignInCard email={email} onEmailChanged={refetch} />
      <SignInMethodsCard />
      <AccountLanguageCard onSaved={onLanguageSaved} />
      <AccountActionsCards email={email} workspaceName={homeWorkspaceName} />
    </div>
  );
};

export const AccountTab = TypedMemo(AccountTabComponent);
